import { TreeNode } from "shared/types/TreeNode"
import { WithID } from "shared/types/WithID"

import { FlattenedTableItemType } from "../types"

export function findIndexRelativeToParent<T extends WithID>(
  nodes: TreeNode<FlattenedTableItemType<T>>[],
  parentID: string | null,
  flattenedTreeIndex: number
): number {
  const node: TreeNode<FlattenedTableItemType<T>> | undefined =
    nodes[flattenedTreeIndex]
  if (!node) {
    return nodes.length
  }

  if (nodes[flattenedTreeIndex]?.id === parentID) {
    return 0
  }
  const siblingsByLevel: Record<number, number> = {}

  let index = flattenedTreeIndex - 1

  while (index >= 0 && nodes[index]?.id !== parentID) {
    if (siblingsByLevel[nodes[index].level] === undefined) {
      siblingsByLevel[nodes[index].level] = 1
    } else {
      siblingsByLevel[nodes[index].level] += 1
    }
    index -= 1
  }
  const parentLevel = nodes[index]?.id === parentID ? nodes[index].level : -1
  return siblingsByLevel[parentLevel + 1] ?? 0
}
